const {forEach} = require('lodash/collection');
const Notification = require('components/Notification/Notification');
const {merge} = require('lodash/object');
const ContentUtils = require('utils/ContentUtils');

let AdminScaffoldingContextHolder = {

    validators: [],

    cleaners: [],

    itemProviders: [],

    isValid() {
        let isValid = true;
        forEach(this.validators, function (validator) {
            if (!validator()) {
                isValid = false;
            }
        });
        return isValid;
    },

    /**
     * Clean each of field from the form.
     */
    clean() {
        forEach(this.cleaners, function (cleaner) {
            cleaner();
        });
    },

    /**
     * Retrieve the object that came from of each field of form.
     * @returns {*}
     */
    getItem() {
        let item = {};
        forEach(this.itemProviders, itemProvider => {
            item = merge(item, itemProvider());
        });
        return item;
    },

    addValidator(validator) {
        this.validators.push(validator);
    },

    addCleaner(cleaner) {
        this.cleaners.push(cleaner);
    },

    addItemProvider(itemProvider) {
        this.itemProviders.push(itemProvider);
    },

    cleanContext() {
        this.validators = [];
        this.cleaners = [];
        this.itemProviders = [];
    }
};

module.exports = {

    /**
     * Retrieve the new context holder instance each time to be called. For that, take care
     * when consume them to share the same context by a group of component.
     * @returns {*}
     */
    getContextHolderInstance() {
        AdminScaffoldingContextHolder.cleanContext();
        return Object.assign({}, AdminScaffoldingContextHolder);
    },

    /**
     * Update the row selected item and update scroll position
     * @param obj
     * @param itemIndex
     * @param lastRowScrollPosition
     * @param headerActiveFilters
     */
    __onRowSelection(obj,
                    itemIndex,
                    lastRowScrollPosition,
                    headerActiveFilters) {
        this.setState(
            {
                selectedItem: obj,
                isEditMode: !!obj,
                headerActiveFilters
            },
            () => {
                // stay the position of the scroll after row select when
                // the offset Y es outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;
            }
        );
    },

    __onCancel() {
        this.setState({
            selectedItem: null,
            isEditMode: false
        });
    },

    __onFailureShowMessageError(messageInfo) {
        if (messageInfo) {
            const messageError = ContentUtils.formatMessageError(messageInfo);
            Notification.show(messageError);
        }
    },

    __onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    __addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    }

};



/** WEBPACK FOOTER **
 ** ./src/components/Commons/AdminScaffolding/AdminScaffoldingContextHolder.js
 **/